<common-card class="qonto-offer-card">
  <common-card-body>
    <h6 class="mt-2 mb-0">{{'recruitment.process.qonto.title' | translate}}</h6>

    <p>{{'recruitment.process.qonto.description' | translate}}
      <span [innerHTML]="'recruitment.process.qonto.partner_offer' | translate"></span></p>

    <div class="mb-2" [formGroup]="form">
      <nb-checkbox formControlName="answer">
        {{'recruitment.process.qonto.checkbox_label' | translate}}
      </nb-checkbox>
    </div>

    <nb-alert outline="info" *ngIf="this.form.get('answer').value">
      <div class="d-flex align-items-center">
        <div class="mr-3">
          <nb-icon icon="info-circle" style="font-size:2rem"></nb-icon>
        </div>
        <span>{{'recruitment.process.qonto.alert_message' | translate}}</span>
      </div>
    </nb-alert>

    <div>
      <button nbButton
              class="w-100 mb-2"
              status="primary"
              [disabled]="!this.form.get('answer').value"
              (click)="acceptQontoOffer()">
        {{ 'recruitment.process.qonto.validate_button' | translate }}
      </button>
      <button nbButton
              class="w-100"
              status="info"
              (click)="closeDialog()">
        {{ 'recruitment.process.qonto.back_button' | translate }}
      </button>
    </div>
  </common-card-body>
</common-card>
